import React from "react";

import PaginaFotos from "../../../components/Fotos/PaginaFotos/index";

export default function PendentesUpload() {

    return (<>  <PaginaFotos titulo={"Pendentes Upload"} diretorio={"upload_pendentes"} /> </>);
}
